import * as ALERT_DISCHARGE_CONFIG from "../files/common/alertDischargePropertyConfig.i18n";
import * as AVAIBILITIES_PROPERTY_CONFIGS from "../files/common/availabilitiesPropertyConfig.i18n";
import * as DIVISION_PROPERTY_CONFIGS from "../files/common/divisionsPropertyConfig.i18n";
import * as FLUX_PROPERTY_CONFIGS from "../files/common/fluxPropertyConfig.i18n";
import * as PLANE_TYPES_PROPERTY_CONFIGS from "../files/common/planeTypesPropertyConfig.i18n";
import * as PRODUCT_PREFIX_PROPERTY_CONFIG from "../files/common/productPrefixPropertyConfig.i18n";
import * as RECURRING_TASK_DATA_CONFIG from "../files/common/recurringTaskDataPropertyConfig.i18n";
import * as REF_CODE_EVENTS_CONFIGS from "../files/common/refCodeEventsPropertyConfig.i18n";
import * as GROUPS from "../files/common/refGroupsPropertyConfig.i18n";
import * as INSTRUCTOR_ROLES_CONFIGS from "../files/common/refInstructorRolesPropertyConfig.i18n";
import * as ORGANIZATIONS_PROPERTY_CONFIGS from "../files/common/refOrganizationsPropertyConfig.i18n";
import * as REF_RULES_CATEGORIES from "../files/common/refRulesCategoriesPropertyConfig.i18n";
import * as REF_RULES from "../files/common/refRulesPropertyConfig.i18n";
import * as SEASONS from "../files/common/refSeasonsPropertyConfig.i18n";
import * as SERVICE_PROVIDER_CONFIGS from "../files/common/refServiceProviderPropertyConfig.i18n";
import * as SITES_PROPERTY_CONFIG from "../files/common/refSitesPropertyConfig.i18n";
import * as REF_TIME_CODES from "../files/common/refTimeCodesPropertyConfig.i18n";
import * as TIME_VACATIONS_PROPERTY_CONFIGS from "../files/common/refTimeVacationsPropertyConfigs.i18n";
import * as RESOURCE_CATEGORIES_PROPERTY_CONFIGS from "../files/common/resourceCategoriesPropertyConfig.i18n";
import * as RESOURCE_PROPERTY_CONFIGS from "../files/common/resourcePropertyConfig.i18n";
import * as RESOURCES_SKILL_PROPERTY_CONFIGS from "../files/common/resourcesSKillPropertyConfig.i18n";
import * as RESOURCES_SITUATIONS_PROPERTY_CONFIGS from "../files/common/resourcesSituationPropertyConfig.i18n";

import * as FILTER_TEMPLATES from "../files/common/filterTemplatesPropertyConfig.i18n";
import * as REF_COUNTER_PREFIX_CODE_PROPERTY_CONFIGS from "../files/common/refCounterPrefixCodePropertyConfig.i18n";
import * as RESOURCE_TYPE_PROPERTY_CONFIGS from "../files/common/resourceTypesPropertyConfig.i18n";
import * as RESOURCES_AVAILABILITIES from "../files/common/resourcesAvailabilitiesPropertyConfig.i18n";
import * as SKILL_LEVEL_PROPERTY_CONFIGS from "../files/common/skillLevelPropertyConfig.i18n";
import * as SKILLS_PROPERTY_CONFIGS from "../files/common/skillsPropertyConfig.i18n";
import * as TASK_CATEGORIES_PROPERTY_CONFIGS from "../files/common/taskCategoriesPropertyConfig.i18n";
import * as TASK_DRY_DATA_CONFIGS from "../files/common/taskDryDataConfig.i18n";
import * as TASK_PROPERTY_CONFIGS from "../files/common/taskPropertyConfig.i18n";
import * as TASK_TYPES_PROPERTY_CONFIGS from "../files/common/taskTypesPropertyConfig.i18n";
import * as TIMETABLES from "../files/common/timetablePropertyConfig.i18n";
import * as TRAINEES_PROPERTY_CONFIGS from "../files/common/traineesPropertyConfigs.i18n";
import * as TRAINING_COURSE_GROUPS from "../files/common/trainingCourseGroupsConfig.i18n";
import * as TRAINING_COURSE_MODULE from "../files/common/trainingCourseModulesPropertyConfigs.i18n";
import * as TRAINING_COURSE_PLANNING_ITEM_PROPERTY_CONFIGS from "../files/common/trainingCoursePlanningItemsPropertyConfigs.i18n";
import * as TRAINING_COURSE_PROPERTY_CONFIG from "../files/common/trainingCoursePropertyConfig.i18n";
import * as TRAINING_PRODUCT_MODULE_TASK_NEEDED_RESOURCES_PROPERTY_CONFIG from "../files/common/trainingProductModuleTasksNeededResourcesPropertyConfigs.i18n";
import * as TRAINING_PRODUCT_MODULE_TASKS_PROPERTY_CONFIGS from "../files/common/trainingProductModuleTasksPropertyConfigs.i18n";
import * as TRAINING_PRODUCT_MODULES_PROPERTY_CONFIGS from "../files/common/trainingProductModulesPropertyConfigs.i18n";
import * as TRAINING_PRODUCT_STATES_PROPERTY_CONFIGS from "../files/common/trainingProductStatesPropertyConfigs.i18n";
import * as TRAINING_PRODUCTS_PROPERTY_CONFIGS from "../files/common/trainingProductsPropertyConfigs.i18n";
import * as USERS_PROFILES_APPLICATION_PAGES_ACCESS_CONFIGS from "../files/common/usersProfilesApplicationPagesAccess.i18n";
import * as USERS_PROFILES_CONFIG from "../files/common/usersProfilesPropertyConfig.i18n";

import * as REF_RESOURCES_GROUPS_CONFIGS from "../files/common/refResourcesGroupsPropertyConfig.i18n";
import * as TASK_CANCEL_REASON_CONFIGS from "../files/common/taskCancelReasonPropertyConfig.i18n";


export const refResourcesGroupsPropertyConfigs = REF_RESOURCES_GROUPS_CONFIGS;
export const divisionPropertyConfig = DIVISION_PROPERTY_CONFIGS;
export const resourceCategoriesPropertyConfig = RESOURCE_CATEGORIES_PROPERTY_CONFIGS;
export const resourcePropertyConfig = RESOURCE_PROPERTY_CONFIGS;
export const resourceTypesPropertyConfig = RESOURCE_TYPE_PROPERTY_CONFIGS;
export const skillsPropertyConfig = SKILLS_PROPERTY_CONFIGS;
export const taskCategoriesPropertyConfig = TASK_CATEGORIES_PROPERTY_CONFIGS;
export const taskTypesPropertyConfig = TASK_TYPES_PROPERTY_CONFIGS;
export const planeTypesPropertyConfig = PLANE_TYPES_PROPERTY_CONFIGS;
export const taskPropertyConfigs = TASK_PROPERTY_CONFIGS;
export const trainingProductStatesPropertyConfigs = TRAINING_PRODUCT_STATES_PROPERTY_CONFIGS;
export const productPrefixPropertyConfig = PRODUCT_PREFIX_PROPERTY_CONFIG;
export const refCounterPrefixCodePropertyConfig = REF_COUNTER_PREFIX_CODE_PROPERTY_CONFIGS;
export const sitesPropertyConfig = SITES_PROPERTY_CONFIG;
export const skillLevelPropertyConfig = SKILL_LEVEL_PROPERTY_CONFIGS;
export const fluxPropertyConfigs = FLUX_PROPERTY_CONFIGS;
export const trainingProductsPropertyConfigs = TRAINING_PRODUCTS_PROPERTY_CONFIGS;
export const trainingProductModulesPropertyConfigs = TRAINING_PRODUCT_MODULES_PROPERTY_CONFIGS;
export const trainingProductModuleTasksPropertyConfigs = TRAINING_PRODUCT_MODULE_TASKS_PROPERTY_CONFIGS;
export const refOrganizationsPropertyConfigs = ORGANIZATIONS_PROPERTY_CONFIGS;

export const refCodeEventsPropertyConfigs = REF_CODE_EVENTS_CONFIGS;

export const refTimeVacationsPropertyConfigs = TIME_VACATIONS_PROPERTY_CONFIGS;
export const Availabilities = AVAIBILITIES_PROPERTY_CONFIGS;
export const timeTablesPropertyConfigs = TIMETABLES;
export const trainingCoursePropertyConfig = TRAINING_COURSE_PROPERTY_CONFIG;
export const traineesPropertyConfigs = TRAINEES_PROPERTY_CONFIGS;

export const refServiceProviderPropertyConfigs = SERVICE_PROVIDER_CONFIGS;
export const trainingProductStatesPropertyConfig = TRAINING_PRODUCT_STATES_PROPERTY_CONFIGS;
export const usersProfilesApplicationPagesAccess = USERS_PROFILES_APPLICATION_PAGES_ACCESS_CONFIGS;
export const usersProfiles = USERS_PROFILES_CONFIG;
export const trainingProductModuleTasksNeededResourcesPropertyConfig = TRAINING_PRODUCT_MODULE_TASK_NEEDED_RESOURCES_PROPERTY_CONFIG;
export const trainingCoursePlanningItemsPropertyConfigs = TRAINING_COURSE_PLANNING_ITEM_PROPERTY_CONFIGS;

export const refRulesPropertyConfig = REF_RULES;
export const refRulesCategoriesPropertyConfig = REF_RULES_CATEGORIES;

export const refInstructorRolesPropertyConfigs = INSTRUCTOR_ROLES_CONFIGS;
export const taskDryDataConfig = TASK_DRY_DATA_CONFIGS;
export const recurringTaskDataConfig = RECURRING_TASK_DATA_CONFIG;
export const refSeasonsPropertyConfig = SEASONS;
export const refGroupsPropertyConfig = GROUPS;
export const refTimeCodesPropertyConfig = REF_TIME_CODES;
export const resourcesSkillPropertyConfig = RESOURCES_SKILL_PROPERTY_CONFIGS;
export const resourcesSituationPropertyConfig = RESOURCES_SITUATIONS_PROPERTY_CONFIGS;
export const trainingCourseGroups = TRAINING_COURSE_GROUPS;
export const filterTemplatesPropertyConfig = FILTER_TEMPLATES;
export const alertDischarge = ALERT_DISCHARGE_CONFIG;
export const resourceAvailabilities = RESOURCES_AVAILABILITIES;
export const trainingCourseModule = TRAINING_COURSE_MODULE;
export const taskCancelReasonPropertyConfigs = TASK_CANCEL_REASON_CONFIGS;